import { render, staticRenderFns } from "./InvoiceTracker.vue?vue&type=template&id=4deec2c2&"
import script from "./InvoiceTracker.vue?vue&type=script&lang=js&"
export * from "./InvoiceTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports